var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('tree',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.treeLoading),expression:"treeLoading"}],ref:"tree",attrs:{"items":_vm.data,"defaultExpandAll":true,"defaultParent":0,"showCheckbox":_vm.multiple,"relationType":_vm.relationType,"label":_vm.lableKey},on:{"check":_vm.check,"nodeClick":_vm.click}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }